import { useProgressNoteFormContext } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { useEpisodeOfCareStoreContext } from "@/modules/patients/detail/store/useEpisodeOfCareStore"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"

const useEditableProgressNotesInContextOfAppointment = () => {
  const appointmentId = useAppointmentParam()
  const progressNoteAndParentData = useEpisodeOfCareStoreContext((state) => state.progressNoteAndParentData)
  const progressNoteForms = useProgressNoteFormContext((state) => state.progressNoteForms)

  if (!appointmentId) return []

  return progressNoteAndParentData
    .map((item) => item.episodeOfCareProgressNoteData)
    .filter((progressNote) => progressNoteForms.has(progressNote.id))
}

export { useEditableProgressNotesInContextOfAppointment }
